import * as React from "react";
import { forwardRef } from "react";
const SvgIconGoogleTopic = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9 3.90002H11V6.90002H14V8.90002H11V11.9H9V8.90002H6V6.90002H9V3.90002Z", fill: "#DADADA" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 0H18C19.1 0 20 0.9 20 2V14C20 15.1 19.1 16 18 16H4L0 20V2C0 0.9 0.9 0 2 0ZM3.2 14H18V2H2V15.2L3.2 14Z", fill: "#DADADA" }));
const ForwardRef = forwardRef(SvgIconGoogleTopic);
export default ForwardRef;
